import { service } from '@ember/service';
import Component from '@glimmer/component';
import ContactModel from 'donor-elf-web/models/contact';
import ContactCampaignSummaryModel from 'donor-elf-web/models/contact-campaign-summary';
import CampaignService from 'donor-elf-web/services/campaign-service';

interface ComponentArgs {
  contact: ContactModel;
  model: ContactCampaignSummaryModel[];
}

export default class CampaignSummariesComponent extends Component<ComponentArgs> {
  @service declare campaignService: CampaignService;

  get showCard() {
    return this.campaignService.campaignsEnabled && this.args.model.length > 0;
  }

  get sortedSummaries() {
    let summaries = this.args.model;
    return this.campaignService.sortedCampaigns
      .filter((c) => summaries.some((s) => s.campaignId === c.id))
      .map((c) => summaries.find((s) => s.campaignId === c.id)!);
  }
}
